<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Создать партнера</strong>
                </CCardHeader>
                <CCardBody>
                    <CForm>
                        <CInput
                            v-model="partner.title"
                            label="Название"
                            :horizontal="true"
                        />
                        <CInput
                            v-model="partner.legal_entity"
                            label="Юр. лицо"
                            :horizontal="true"
                        />
                        <CInput
                            v-model="partner.individual_taxpayer_number"
                            label="ИНН"
                            :horizontal="true"
                        />
                        <CSelect
                            :value.sync="partner.vat"
                            :horizontal="true"
                            :options="vatOptions"
                            label="Значения ставки НДС"
                            placeholder="Выберите значения ставки НДС"
                        />
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Использовать значения ставки НДС для каждого товара свою</CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="partner.use_product_vat"
                                />
                            </CCol>
                        </CRow>
                        <CSelect
                            :value.sync="partner.payment"
                            :horizontal="true"
                            :options="paymentTypeOptions"
                            label="Тип оплаты"
                            placeholder="Выберите тип оплаты"
                        />
                        
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Признак способа расчета
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    :value.sync="partner.pre_receipt_method"
                                    :horizontal="true"
                                    :options="receiptMethods"
                                    label="Чек аванса"
                                    placeholder="Чек аванса"
                                />
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    :value.sync="partner.final_receipt_method"
                                    :horizontal="true"
                                    :options="receiptMethods"
                                    label="Финальный чек"
                                    placeholder="Финальный чек"
                                />
                            </CCol>
                        </CRow>
                        <CSelect
                            :value.sync="partner.receipt_object"
                            :horizontal="true"
                            :options="receiptObjects"
                            label="Предмет расчета"
                            placeholder="Предмет расчета"
                        />
                        
                        <CInput
                            v-model="partner.telegram_chat_id"
                            label="Телеграм чат"
                            :horizontal="true"
                        />
                        <CInput
                            v-model="partner.contract_id"
                            label="№ договора"
                            :horizontal="true"
                        />
                        <CInput
                            v-model="partner.phone"
                            label="Номер телефона партнера"
                            :horizontal="true"
                        />
                        <PartnerSignersUpdate :signers="partner.signers" @set-signers="setSigners" />
                        <CRow class="mb-3">
                            <CCol cols="12" md="3"> Дата договора: </CCol>
                            <CCol
                                cols="12"
                                md="9"
                                class="pl-2">
                                <DatePicker
                                    v-model="datepicker.date"
                                    :language="datepicker.lang"
                                    :format="datepicker.format"
                                    input-class="custom-datepicker"
                                    placeholder="Выберите дату..."
                                />
                            </CCol>
                        </CRow>
                        <CInput
                            v-model.number="partner.notification_delay"
                            label="Задержка повтора уведомления о непринятом заказе (в секундах)*"
                            placeholder="Задержка"
                        />
                        <CInput
                            v-model.number="partner.try_count"
                            label="Макс. кол-во уведомлений о непринятом заказе*"
                            placeholder="Кол-во уведомлений"
                        />
                        <CInput
                            v-model="partner.mircity_commission"
                            label="Комиссия МИРСИТИ (%)"
                            :horizontal="true"
                        />
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Отключить применение тарифов по зонам</CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="partner.delivery_zone_disabled"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Активен</CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="partner.enabled"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="create"
                    >Создать</CButton
                    >
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="$router.push('/partners')"
                    >Отмена</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import { PAYMENT_TYPE } from '../../utils/payment';
    import { paymentTypeTitle } from '../../utils/payment-views';
    import DatePicker from 'vuejs-datepicker';
    import PartnerSignersUpdate from '@/components/partner/PartnerSignersUpdate';
    import { ru } from 'vuejs-datepicker/dist/locale';
    import moment from 'moment';

    export default {
        name: 'PartnerCreate',

        components: {
            DatePicker,
            PartnerSignersUpdate
        },

        data() {
            return {
                partner: {
                    title: '',
                    payment: 1,
                    telegram_chat_id: '',
                    mircity_commission: 0,
                    notification_delay: null,
                    try_count: null,
                    use_product_vat: false,
                    enabled: true,
                    delivery_zone_disabled: false,
                    signers: []
                },
                signers: [],
                datepicker: {
                    lang: ru,
                    format: 'dd.MM.yyyy',
                    date: null,
                },
                vatOptions: [
                    { value: null, label: 'НДС не облагается' },
                    { value: 0, label: 'НДС 0%' },
                    { value: 5, label: 'НДС 5%' },
                    { value: 7, label: 'НДС 7%' },
                    { value: 10, label: 'НДС 10%' },
                    { value: 20, label: 'НДС 20%' },
                    { value: 22, label: 'НДС 22%' },
                    { value: 105, label: 'Расчетный НДС 5/105' },
                    { value: 107, label: 'Расчетный НДС 7/107' },
                    { value: 110, label: 'Расчетный НДС 10/110' },
                    { value: 120, label: 'Расчетный НДС 20/120' },
                    { value: 12, label: 'НДС 12% (только для онлайн-касс в Казахстане)' },
                ],
                receiptMethods: [
                    { value: 0, label: 'Unknown, неизвестный способ расчета' },
                    { value: 1, label: 'FullPrepayment, предоплата 100%' },
                    { value: 2, label: 'PartialPrepayment, предоплата' },
                    { value: 3, label: 'AdvancePay, аванс' },
                    { value: 4, label: 'FullPay, полный расчёт' },
                    { value: 5, label: 'PartialPayAndCredit, частичный расчёт и кредит' },
                    { value: 6, label: 'Credit, передача в кредит' },
                    { value: 7, label: 'CreditPayment, оплата кредита' },
                ],
                receiptObjects: [
                    { value: 0, label: 'Unknown, неизвестный предмет оплаты' },
                    { value: 1, label: 'Commodity, товар' },
                    { value: 2, label: 'ExcisedCommodity, подакцизный товар' },
                    { value: 3, label: 'Job, работа' },
                    { value: 4, label: 'Service, услуга' },
                    // { value: 5, label: 'GamblingBet, ставка азартной игры' },
                    // { value: 6, label: 'GamblingWin, выигрыш азартной игры' },
                    // { value: 7, label: 'LotteryTicket, лотерейный билет' },
                    // { value: 8, label: 'LotteryWin, выигрыш лотереи' },
                    // { value: 9, label: 'RidAccess, предоставление РИД' },
                    { value: 10, label: 'Payment, платеж' },
                    { value: 11, label: 'AgentReward, агентское вознаграждение' },
                    // { value: 12, label: 'Composite, Выплата' },
                    { value: 13, label: 'Another, иной предмет расчета' },
                    // { value: 14, label: 'PropertyLaw, Имущественное право' },
                    // { value: 15, label: 'NonOperatingIncome, Внереализационный доход' },
                    // { value: 16, label: 'InsuranceContributions, Страховые взносы' },
                    // { value: 17, label: 'TradeFee, Торговый сбор' },
                    // { value: 18, label: 'ResortFee, Курортный сбор' },
                    // { value: 19, label: 'CautionMoney, Залог' },
                    // { value: 20, label: 'ExpensesIncurred, Расход' },
                    // { value: 21, label: 'ContributionsOnIp, Взносы на обязательное пенсионное страхование ИП' },
                    // { value: 22, label: 'ContributionsSimple, Взносы на обязательное пенсионное страхование' },
                    // { value: 23, label: 'ContributionsMedical, Взносы на обязательное медицинское страхование ИП' },
                    // { value: 24, label: 'ContributionsMedicalSimple, Взносы на обязательное медицинское страхование' },
                    // { value: 25, label: 'ContributionsSocial, Взносы на обязательное социальное страхование' },
                    // { value: 26, label: 'CasinoPayment, Платеж казино' },
                    // { value: 27, label: 'CashWithdrawal, Выдача денежных средств (ффд 1.2)' },
                    // { value: 30, label: 'Atnm, АТНМ (ффд 1.2)' },
                    // { value: 31, label: 'Atm, АТМ (ффд 1.2)' },
                    // { value: 32, label: 'Tnm, ТНМ (ффд 1.2)' },
                    // { value: 33, label: 'Tm, ТМ (ффд 1.2)' },
                ]
            };
        },

        computed: {
            paymentTypeOptions() {
                const options = [];
                for (const key in PAYMENT_TYPE) {
                    options.push({
                        value: PAYMENT_TYPE[key],
                        label: paymentTypeTitle(PAYMENT_TYPE[key]),
                    });
                }
                return options;
            },
        },

        mounted() {},

        methods: {
            create() {
                if (!this.partner.title) {
                    this.$root.$emit('showError', 'Укажите название партнера.');
                    return;
                }
                if (!this.partner.payment) {
                    this.$root.$emit('showError', 'Укажите тип оплаты.');
                    return;
                }
                if (this.partner.notification_delay && !this.partner.try_count) {
                    this.$root.$emit('showError', 'Заполните макс. кол-во уведомлений!');
                    return;
                }
                if (this?.partner?.notification_delay && this?.partner?.notification_delay < 20) {
                    this.$root.$emit('showError', 'Задержка повтора уведомлений не может быть меньше чем 20 сек.');
                    return;
                }
                if (!this.partner.notification_delay && this.partner.try_count) {
                    this.$root.$emit('showError', 'Заполните задержку повтора уведомлений!');
                    return;
                }
                this.partner.contract_date = moment(this.datepicker.date).format('YYYY-MM-DD');
                if (typeof this.partner?.mircity_commission === 'string') {
                    this.partner.mircity_commission = this.partner.mircity_commission.replace(',', '.');
                }
                this.partner.mircity_commission = this.partner.mircity_commission ? parseFloat(this.partner.mircity_commission) : null;
                this.partner.notification_delay = this.partner.notification_delay ? +this.partner.notification_delay : null;
                this.partner.try_count = this.partner.try_count ? +this.partner.try_count : null;
                delete this.partner.signers;
                Vue.axios
                    .post('/partners', this.partner)
                    .then(resp => {
                        this.signers = this.signers.map(signer => ({ ...signer, partner_id: resp.data.id }))
                        Vue.axios
                            .post(`/partners/signers/${resp.data.id}`, this.signers)
                            .catch(err => {
                                this.$root.$emit('showError', 'Ошибка сохранения.');
                            });
                        this.$router.push({ path: '/partners/' + resp.data.id });
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },

            setSigners(signers) {
                this.signers = signers.map(signer => ({ ...signer, partner_id: this.partner.id }));
            },

            goBack() {
                this.$router.push({ path: '/partners' });
            },
        },
    };
</script>
<style>
input.custom-datepicker {
  border: 1px solid;
  border-color: #d8dbe0;
  width: 100%;
  padding: 7px;
  border-radius: 4px;
}
</style>

